import cxs from 'cxs';
import { COLOURS, FONT_SIZES } from '../vars';

const DECORATOR_STYLES = ({ hasPrefix, hasSuffix, type, invalid, disabled }) => ({

  ...(hasPrefix ? {
    [` ~ .input-container__decorator${hasSuffix ? ':first-of-type' : ''}`]: {
      ...(disabled ? {
        color: COLOURS.grey.nevada,
        cursor: 'default',
        pointerEvents: 'none'
      } : {})
    }
  } : {}),

  ...(hasSuffix ? {
    [` ~ .input-container__decorator${hasPrefix ? ':last-of-type' : ''}`]: {
      ...(disabled ? {
        color: COLOURS.grey.nevada,
        cursor: 'default',
        pointerEvents: 'none'
      } : {})
    }
  } : {}),

  ':hover:not(:focus) ~ .input-container__decorator': {
    ...(type === 'SECONDARY' ? {
      background: `${COLOURS.grey.mischka.russian} !important`
    } : {}),

    ...(disabled ? {
      background: COLOURS.grey.athens.parthenon,
      color: COLOURS.grey.nevada,
      cursor: 'default',
      pointerEvents: 'none'
    } : {})
  },

  ':focus ~ .input-container__decorator': {

    ...(type === 'SECONDARY' ? {
      background: `${COLOURS.grey.mischka.russian} !important`
    } : {}),

    ...(disabled ? {
      background: COLOURS.grey.athens.parthenon,
      color: COLOURS.grey.nevada,
      cursor: 'default',
      pointerEvents: 'none',
      borderColor: 'transparent !important'
    } : {}),

    ...(invalid ? {
      borderColor: `${COLOURS.red.thunderBird} !important`
    } : {})
  }
});

const INPUT_CORE = {
  border: 'none',
  color: COLOURS.mono.black,
  caretColor: COLOURS.cyan.jungleGreen.monkey,
  fontSize: FONT_SIZES.default,
  width: '100%',
  lineHeight: '40px',
  boxSizing: 'border-box',
  height: '40px',
  minHeight: '40px',
  letterSpacing: '0.3px',
  order: 2,
  outline: 'none !important',

  '::placeholder': {
    textIndent: '3px',
    color: COLOURS.grey.nevada
  }
};

const AUTO_GROW = {
  width: 'unset',
  display: 'block',
  cursor: 'text',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',

  '&:focus': {
    textOverflow: 'unset'
  }
};

function getOptionalStyles({ if: condition, styles }) {
  return condition ? styles : {};
}










export const INPUT_STYLE_OBJECT = ({
  disabled,
  valid = true,
  hasPrefix,
  hasSuffix,
  type = 'PRIMARY',
  autoGrow
}) => ({
  ...INPUT_CORE,
  ...getOptionalStyles({
    if: hasPrefix || hasSuffix,
    styles: DECORATOR_STYLES({ hasPrefix, hasSuffix, type, invalid: !valid, disabled })
  }),
  ...getOptionalStyles({ if: autoGrow, styles: AUTO_GROW })
});

export const INPUT = (styleObj) => cxs(INPUT_STYLE_OBJECT(styleObj));